/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const a = ["\u05E9\u05E0\u05D9", "\u05E9\u05DC\u05D9\u05E9\u05D9", "\u05E8\u05D1\u05D9\u05E2\u05D9", "\u05D7\u05DE\u05D9\u05E9\u05D9", "\u05E9\u05D9\u05E9\u05D9", "\u05E9\u05D1\u05EA", "\u05E8\u05D0\u05E9\u05D5\u05DF"], e = ["\u05D9\u05E0\u05D5\u05D0\u05E8", "\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8", "\u05DE\u05E8\u05E5", "\u05D0\u05E4\u05E8\u05D9\u05DC", "\u05DE\u05D0\u05D9", "\u05D9\u05D5\u05E0\u05D9", "\u05D9\u05D5\u05DC\u05D9", "\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8", "\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8", "\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8", "\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8", "\u05D3\u05E6\u05DE\u05D1\u05E8"], t = "\u05E9\u05E0\u05D9\u05DD", s = "\u05E9\u05E0\u05D4", d = "\u05D7\u05D5\u05D3\u05E9", n = "\u05E9\u05D1\u05D5\u05E2", o = "\u05D9\u05D5\u05DD", y = "\u05D4\u05D9\u05D5\u05DD", r = "\u05D0\u05D9\u05DF \u05D0\u05D9\u05E8\u05D5\u05E2\u05D9\u05DD", M = "\u05DB\u05DC \u05D4\u05D9\u05D5\u05DD", Y = "\u05DE\u05D7\u05D9\u05E7\u05D4", l = "\u05E6\u05D5\u05E8 \u05D0\u05D9\u05E8\u05D5\u05E2", m = "dddd D MMMM YYYY", D = { weekDays: a, months: e, years: "\u05E9\u05E0\u05D9\u05DD", year: "\u05E9\u05E0\u05D4", month: "\u05D7\u05D5\u05D3\u05E9", week: "\u05E9\u05D1\u05D5\u05E2", day: "\u05D9\u05D5\u05DD", today: "\u05D4\u05D9\u05D5\u05DD", noEvent: "\u05D0\u05D9\u05DF \u05D0\u05D9\u05E8\u05D5\u05E2\u05D9\u05DD", allDay: "\u05DB\u05DC \u05D4\u05D9\u05D5\u05DD", deleteEvent: "\u05DE\u05D7\u05D9\u05E7\u05D4", createEvent: "\u05E6\u05D5\u05E8 \u05D0\u05D9\u05E8\u05D5\u05E2", dateFormat: "dddd D MMMM YYYY" };
export {
  M as allDay,
  l as createEvent,
  m as dateFormat,
  o as day,
  D as default,
  Y as deleteEvent,
  d as month,
  e as months,
  r as noEvent,
  y as today,
  n as week,
  a as weekDays,
  s as year,
  t as years
};
